//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminDocumentController_retryBobSync,
  Response$AdminDocumentController_retryBobSync$Status$200,
  ResponseContentType$AdminDocumentController_retryBobSync,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminDocumentController_retryBobSync = () =>
  useApiClientMutation<
    Params$AdminDocumentController_retryBobSync,
    Response$AdminDocumentController_retryBobSync$Status$200[ResponseContentType$AdminDocumentController_retryBobSync]
  >({ method: 'AdminDocumentController_retryBobSync' });
